export enum ContactMethod {
  email = 1,
  phone = 2,
}
